<template>
    <div>
        <navigation-bar Close/>
        <div class="address-list p-4 main">
            <div class="text-right">
                <el-switch
                        v-model="isDefault"
                        class="lg">
                </el-switch>
            </div>
            <border-input labelText="公司名稱">
                <img slot="icon" style="width: 20px" src="@/assets/images/profile/company.svg">
                <div slot="input">
                    <input  class="input" placeholder="如果適用請輸入" v-model="name">
                </div>
            </border-input>
            <border-input labelText="地址標籤">
                <img slot="icon" style="width: 20px" src="@/assets/images/profile/tag.svg">
                <div slot="input">
                    <input  class="input" placeholder="例如：家" v-model="title">
                </div>
            </border-input>
            <border-input labelText="城市">
                <img slot="icon" style="width: 20px" src="@/assets/images/profile/house.svg">
                <div slot="input">
                    <el-select placeholder="請選擇縣市" v-model="selectCityIndex" v-if="cityList.length > 0" @change="selectTownshipIndex=0">
                        <el-option
                                v-for="(item,index) in cityList"
                                :key="index"
                                :label="item.name"
                                :value="index"
                        >
                        </el-option>
                    </el-select>
                </div>
            </border-input>
            <border-input labelText="鄉鎮市區">
                <div slot="input">
                    <el-select placeholder="請選擇鄉鎮市區" v-model="selectTownshipIndex" v-if="cityList.length > 0">
                        <el-option
                                v-for="(item,index) in cityList[selectCityIndex].townshipList"
                                :key="index"
                                :label="item.name"
                                :value="index"
                        >
                        </el-option>
                    </el-select>
                </div>
            </border-input>
            <border-input labelText="地址">
                <div slot="input">
                    <input  class="input" placeholder="請輸入地址" v-model="address">
                </div>
            </border-input>
            <border-input labelText="外送指示-填寫放置地點及送餐注意事項">
                <div slot="input">
                    <el-input
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 2}"
                            placeholder="請輸入內容"
                            v-model="content"
                            maxlength="100"
                    >
                    </el-input>
                </div>
            </border-input>
            <div class="footer-button">
                <el-button round @click="$router.go(-1)">取消</el-button>
                <el-button type="primary" round @click="confirmClick">送出</el-button>
            </div>

            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>
        </div>
    </div>

</template>

<script>
    import BorderInput from '@/components/BorderInput.vue';
    export default {
        name: "OrderAddress",
        components: {
          BorderInput,
        },
        data() {
          return {
            isLoading: false,
            id: Number(this.$route.params.id),
            name: '',
            title: '',
            address: '',
            postalCode: '',
            content: '',
            isDefault: false,
            cityList: [],
            selectCityIndex: 0,
            selectTownshipIndex: 0,
          }
        },
        created() {
          this.setupData()
        },
        methods: {
          setupData() {

            this.isLoading = true

            this.$http.fetchWithAuth`GetUserAddress${{
              'id': this.id,
              'getCityList': true,
            }}
            ${json => {
              if (json.status) {
                this.cityList = json.data.cityList
                if(this.id !== 0) {
                  let userAddressData = json.data.userAddressData
                  this.name = userAddressData.name
                  this.title = userAddressData.title
                  this.address = userAddressData.address
                  this.postalCode = userAddressData.postalCode
                  this.content = userAddressData.content
                  this.isDefault = userAddressData.isDefault

                  this.cityList.some((cityItem, cityIndex) => {
                    return cityItem.townshipList.some((townshipItem, townshipIndex) => {
                      if(townshipItem.postalCode === this.postalCode) {
                        this.selectCityIndex = cityIndex
                        this.selectTownshipIndex = townshipIndex
                        return true
                      }
                    })
                  })
                }
              }

              this.isLoading = false
            }}`;

          },
          confirmClick() {

            let self = this

            if(self.address === "") {
              self.$public.showNotify("請輸入地址", false);
              return false
            }

            self.isLoading = true

            self.$http.fetchWithAuth`UpdateUserAddress${{
              "id": self.id,
              "name": self.name,
              "title": self.title,
              "townshipId": self.cityList[self.selectCityIndex].townshipList[self.selectTownshipIndex].id,
              "address": self.address,
              "content": self.content,
              "isDefault": self.isDefault,
            }}
            ${json => {
              if(json.status) {
                this.$router.go(-1)
              }
              self.$public.showNotify(json.message, json.status);
              self.isLoading = false
            }}`;
          }
        }
    }
</script>

<style lang="less" scoped src="../../less/order.less"/>